import { useQuery } from "@tanstack/react-query";
import { ApplicationNotification } from "../types/ApplicationNotification";

export function useFetchApplicationNotification(shouldRefetch = false) {
    return useQuery<ApplicationNotification>(["meta"], {
        refetchOnWindowFocus: false,
        refetchInterval: shouldRefetch ? 900_000 : false,
    });
}
